/**
 * Icon bileşeni `color` prop’u: semantik anahtar veya ham hex.
 * Değerler src/styles/colors.scss ile uyumlu (vuetifyPalette.js ile senkron tutun).
 */
export const ICON_SEMANTIC_COLORS = {
  default: '#171D22',
  foreground: '#171D22',
  muted: '#93A0AF',
  tertiary: '#5C6A75',
  onPrimary: '#FFFFFF',
  primary: '#EB575D',
  info: '#4789F7',
  warning: '#EFB424',
  success: '#00AC4F',
  error: '#E60004',
};

export function resolveIconColor(input) {
  if (input == null || input === '') return null;
  const key = String(input).trim();
  if (key.startsWith('#')) return key;
  if (ICON_SEMANTIC_COLORS[key]) return ICON_SEMANTIC_COLORS[key];
  return key;
}
